export default __webpack_public_path__ + "static/media/bgrolemobile.d7ee7ee3.png";